module.exports = __webpack_public_path__ + "img/rivenditori.f8d159b2.svg";